/**
 * scans for searchie of the type below and converst to supported searchie format
 *
 */

export default function PostSearchieParser(content) {
  // Alternative syntax using RegExp constructor
  const regex =
    /(<video (.*) src="https:\/\/app\.searchie\.io\/)(.*)\/(.*)("><\/video>)/gm

  const subst = `<div class="blog-searchie-video">
  <iframe
    src="https://app.searchie.io/file/$4/embed"
    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
    frameborder="0"
    webkitallowfullscreen="true"
    mozallowfullscreen="true"
    allowfullscreen
    allowautoplay
    width="100%"
    height="100%"
    style="width:100%;height:100%;position:absolute;left:0px;top:0px;"
    allow="autoplay"
  />
</div>`

  const matches = content.matchAll(regex)
  if (!matches)
    return {
      ids: [],
      content: content,
    }

  let ids = []
  try {
    ids = [...content.matchAll(regex)].map(g => g[3])
  } catch (_error) {
    return {
      ids: [],
      content: content,
    }
  }

  return {
    ids: ids,
    content: content.replace(regex, subst),
  }
}
